/**
 * Centralized route strings — change the backend path in exactly one place.
 */
export const ENDPOINTS = {
  printJobs: {
    create: '/print-jobs',
    byId: (jobId: string) => `/print-jobs/${jobId}`,
    updateOptions: (jobId: string) => `/print-jobs/${jobId}/options`,
  },
  printRequests: {
    create: '/print-requests/',
  },
  transactions: {
    create: '/transactions/',
  },
  payments: {
    initiate: '/payments/initiate',
    status: (paymentId: string) => `/payments/${paymentId}/status`,
  },
  otp: {
    request: (jobId: string) => `/print-jobs/${jobId}/otp`,
    verify: '/otp/verify',
  },
  kiosks: {
    byId: (kioskId: string) => `/kiosks/${kioskId}/`, 
  },
  siteInfo: '/site-info/', // public: { website_url, app_url }
  admin: {
    auth: {
      csrf: '/auth/web/csrf/',
      login: '/auth/web/login/',
      logout: '/auth/web/logout/', // GUESS: confirm in your Swagger
      register: '/auth/register/',
    },
    vendors: {
      list: '/vendors/',
      byId: (id: number) => `/vendors/${id}/`,
    },
    transactions: {
      list: '/transactions/', // supports ?vendor=<id>&kiosk=<id>&limit=<n>
    },
    patches: {
      upload: '/patches/upload',
      all: '/patches/all',
      deleteById: (versionId: number) => `/patches/DeleteByID/${versionId}`,
      deploy: '/patches/deploy-patch',
      history: '/patches/history',
      historyExport: '/patches/history/export',
      allExport: '/patches/all/export',
    },
    kioskCrud: {
      list: '/kiosks/', // GUESS: confirm in your Swagger
      byId: (id: number) => `/kiosks/${id}/`,
      rateCharges: '/rate-charges/',
    },
    kiosks: {
      connect: '/kiosks/connect',
      restart: '/kiosks/restart',
    },
  },
} as const;
